import { InputAdornment } from '@mui/material';

import { IconSearchMS } from '../../constants/icons';
import { StyledInputBase } from './styles';

interface SearchProps {
  placeholder?: string;
  width?: string | number;
  withoutBorder?: boolean;
  setSearchField: (value: string) => void;
  disabled?: boolean;
}

export function Search({
  placeholder = 'Pesquisar',
  width = 140,
  setSearchField,
  withoutBorder = false,
  disabled = false,
}: SearchProps): JSX.Element {
  return (
    <StyledInputBase
      placeholder={placeholder}
      inputProps={{ 'aria-label': 'pesquisar', maxLength: 11 }}
      type="search"
      disabled={disabled}
      startAdornment={
        <InputAdornment
          position="start"
          sx={(theme) => ({
            color: theme.palette.secondary.main,
          })}
        >
          {IconSearchMS}
        </InputAdornment>
      }
      onChange={(e) => {
        if (e.target.value.length > 0) {
          setSearchField(e.target.value);
        }
        if (e.target.value.length === 0) {
          setSearchField('');
        }
      }}
      onFocus={(e) => {
        e.target.value = '';
        setSearchField('');
      }}
      customWidth={width}
      withoutBorder={withoutBorder}
    />
  );
}
